import React from "react";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";
import ConnectivityChart from "./ConnectivityChart";

export default function FeatureBox({ title, description }) {
  return (
    <div className="flex connectivity-parent flex-col lg:flex-row items-center bg-white p-2 rounded-lg shadow-lg relative">
      {/* Sol Bölüm - Renkli Arka Plan ve Görsel */}
      <div className="lg:w-1/2 flex justify-center p-6 rounded-lg">
        <ConnectivityChart />
      </div>

      {/* Sağ Bölüm - İkon, Başlık, Metin ve Oklar */}
      <div className="text-center lg:text-end mt-6 lg:mt-0 connectivity-right">
        {/* Oklar ve Metinleri */}
        <div className="arrow-container">
          <div className="arrow blue">
            <span>RAPID DEPLOY: CONNECTIVITY + DEVICE + APP</span>
          </div>
          <div className="arrow brown">
            <span>DIY: SEAMLESS SYSTEM INTEGRATION</span>
          </div>
          <div className="arrow light-blue">
            <span>MARKETPLACE: INNOVATIVE SOLUTIONS</span>
          </div>
          <div className="arrow dark-blue">
            <span>INDUSTRIAL GRADE RELIABILITY</span>
          </div>
          <div className="arrow blue">
            <span>TRANSPARENT PRICING</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-2 mb-3 mr-3 right-2 ">
        <button className="connectivity-button ">
          <Link to="/connectivity">Explore FlexNet Connectivity</Link>
          <FaExternalLinkAlt className="ml-2" />
        </button>
      </div>
    </div>
  );
}
